export default "__VITE_ASSET__CSYXuGaa__"